module.exports = __webpack_public_path__ + "img/alipay.11d343c0.png";